import { ChipField, Datagrid, ReferenceArrayField, SingleFieldList, TextField } from "react-admin";
import { List } from "@react-admin/ra-rbac";

export const StageList = ({ rowClick = undefined, hideDetails = false, ...props }) => <List {...props} title=" " basePath="/stage" resource="stage" bulkActionButtons={false} actions={null} >
    <Datagrid rowClick={rowClick}>
        <TextField source="name" />
        {!hideDetails && <TextField source="internalId" />}
        {!hideDetails && <TextField source="workflowId" />}
        <ReferenceArrayField reference="stage" source="incoming">
            <SingleFieldList linkType={false}>
                <ChipField source="name" />
            </SingleFieldList>
        </ReferenceArrayField>
        <ReferenceArrayField reference="stage" source="incomingError">
            <SingleFieldList linkType={false}>
                <ChipField source="name" />
            </SingleFieldList>
        </ReferenceArrayField>
        <ReferenceArrayField reference="stage" source="outgoing">
            <SingleFieldList linkType={false}>
                <ChipField source="name" />
            </SingleFieldList>
        </ReferenceArrayField>
        <ReferenceArrayField reference="stage" source="outgoingError">
            <SingleFieldList linkType={false}>
                <ChipField source="name" />
            </SingleFieldList>
        </ReferenceArrayField>
    </Datagrid>
</List>
